var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2304,
    height: 1778,
    viewBox: "0 0 2304 1778",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M933.203 5.26982C541.517 -12.8306 147.865 99.2369 0 157.533V1777.5H2304V50.5211C2304 50.5211 1740.54 -19.394 1586.84 5.26982C1532.17 12.8117 1324.89 23.3702 933.203 5.26982Z",
    fill: "url(#paint0_linear_83_92)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_92",
    x1: 1249.5,
    y1: -4.22716e-7,
    x2: 1249.68,
    y2: 62.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C5DB3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector4.e56263369a2cbf3bf737b9b7a3b80847.svg";
export { ForwardRef as ReactComponent };